var $406a68cfeee85b97$exports = {};
$406a68cfeee85b97$exports = {
    "info": `Inform\u{101}cija`,
    "negative": `K\u{13C}\u{16B}da`,
    "notice": `Br\u{12B}din\u{101}jums`,
    "positive": `Izdev\u{101}s`
};


export {$406a68cfeee85b97$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
